<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteProductoPaginaIdroop"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionProductSalesLettersModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionProductSalesLettersModalDelete.messageDelete.element') }}
          <b>{{ $modal.element.nombre }}</b>
          {{ $t('mEditionProductSalesLettersModalDelete.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
          {{ $t('mEditionProductSalesLettersModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionProductSalesLettersModalDelete.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductSalesLettersModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductSalesLettersModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    deleteProductoPaginaIdroop () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('producto', 'deleteProductoPaginaIdroop', {}, [this.$modal.element.id])
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductSalesLettersModalDelete', 'deleteProductoPaginaIdroop', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductSalesLettersModalDelete', 'deleteProductoPaginaIdroop', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
